"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Minimum percentage of the minefield tiles that need to be revealed at the
 * start of the game.
 */
exports.initialPatchMinSize = 0.06;
/**
 * Data for each of the valid minefield configurations.
 */
exports.difficulties = [
    { name: 'Beginner', rows: 9, cols: 9, mines: 10 },
    { name: 'Intermediate', rows: 16, cols: 16, mines: 40 },
    { name: 'Expert', rows: 16, cols: 30, mines: 99 },
];
//# sourceMappingURL=data.js.map


//////////////////
// WEBPACK FOOTER
// ./src/js/data.js
// module id = 8
// module chunks = 0